import {
  EsignatureProvider,
  EsignatureProviderConnector,
  EsignatureProviderConnectorType,
  EsignatureProviderId,
  EsignatureProviderMin,
  CreateEsignatureProvider,
  UpdateEsignatureProvider,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state/index.ts"; // Updated import to include q
import {platformedClient} from "..";

export async function listConnectors(): Promise<EsignatureProviderConnector[]> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/esignature_provider_connectors`,
    {},
  );
}

export async function getConnector(
  connectorType: EsignatureProviderConnectorType,
): Promise<EsignatureProviderConnector> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/esignature_provider_connectors/{esignature_provider_connector_type}`,
    {path: {esignature_provider_connector_type: connectorType}},
  );
}

export async function create(payload: CreateEsignatureProvider): Promise<EsignatureProvider> {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/esignature_providers`,
    {body: payload},
  );
  await invalidateQueries([q.vendorToolkit.esignatureProviders.filter()]);
  return res;
}

export async function update(providerId: EsignatureProviderId, payload: UpdateEsignatureProvider) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}`,
    {path: {esignature_provider_id: providerId}, body: payload},
  );
  await invalidateQueries([
    q.vendorToolkit.esignatureProviders.filter(),
    q.vendorToolkit.esignatureProvider.filter(providerId),
  ]);
  return res;
}

export async function delete_(providerId: EsignatureProviderId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}`,
    {path: {esignature_provider_id: providerId}},
  );
  await invalidateQueries([
    q.vendorToolkit.esignatureProviders.filter(),
    q.vendorToolkit.esignatureProvider.filter(providerId),
  ]);
  return res;
}

export async function updateName(providerId: EsignatureProviderId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}/name`,
    {path: {esignature_provider_id: providerId}, body: name},
  );
  await invalidateQueries([
    q.vendorToolkit.esignatureProviders.filter(),
    q.vendorToolkit.esignatureProvider.filter(providerId),
  ]);
  return res;
}

export async function list(): Promise<EsignatureProviderMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/esignature_providers`, {});
}

export async function get(providerId: EsignatureProviderId): Promise<EsignatureProvider> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}`,
    {path: {esignature_provider_id: providerId}},
  );
}

export async function sync(providerId: EsignatureProviderId) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/esignature_providers/{esignature_provider_id}/sync`,
    {path: {esignature_provider_id: providerId}},
  );
  await invalidateQueries([
    q.vendorToolkit.esignatureProviders.filter(),
    q.vendorToolkit.esignatureProvider.filter(providerId),
  ]);
  return res;
}
